import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'kb-section-header',
    template: `<h3
        class="uppercase text-white rounded-sm text-center px-2 py-1 text-lg"
        [ngClass]="colorClass"
    >
        <ng-content></ng-content>
    </h3>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass],
})
export class SectionHeaderComponent implements OnInit {
    @Input() color: 'plantation' | 'sienna' | 'galliano' = 'plantation';
    colorClass: string;
    ngOnInit() {
        this.colorClass = this.getColorClass(this.color);
    }

    private getColorClass(color: typeof this['color']): string {
        switch (color) {
            case 'galliano':
                return 'bg-galliano';
            case 'sienna':
                return 'bg-sienna';
            case 'plantation':
                return 'bg-plantation';
        }
    }
}
